import React from "react";
import "../styles/PopUpStyles.css"; // Import styles

interface PopupProps {
  title: string;
  body: string;
  onClose: () => void;
}

const Popup: React.FC<PopupProps> = ({ title, body, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <h2>{title}</h2>
        </div>
        <div className="popup-body">
          <p>{body}</p>
        </div>
        <div className="popup-footer">
          <button onClick={onClose} className="popup-button">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;
